"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueByPath = void 0;
const pointer = require("jsonpointer");
function getValueByPath(context, path = context.dataPath.dotOnly) {
    if (context.data === null || typeof context.data !== 'object')
        return context.data;
    return pointer.get(context.data, path.replace(/\./g, '/'));
}
exports.getValueByPath = getValueByPath;
